import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

import { AuthService } from 'src/lib/lib-ngx/web-services/auth.service';

export const forgotPasswordGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    return true;
  }

  if (route.queryParams['token']) {
    authService.logout();
    return true;
  }

  router.navigate(['/home'], { replaceUrl: true });

  return false;
};
